module.exports = __webpack_public_path__ + "img/logo_placeholder.1e4a3ef6.png";